import { ISection } from '@zmedia/bm-soccer-ui/interface';
import { SECTION_ID } from '@zmedia/bm-soccer-ui/constants';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import { MatchesHotSection } from '@zmedia/bm-soccer-ui/modules/match';
import { ContentHotSection } from '@zmedia/bm-soccer-ui/modules/content';
import { TournamentsHotSection } from '@zmedia/bm-soccer-ui/modules/tournament/components/section/hot';

const SECTION_MAP = {
    [SECTION_ID.CONTENT_TOP]: ContentHotSection,
    [SECTION_ID.MATCHES_TOP]: MatchesHotSection,
    [SECTION_ID.TOURNAMENTS_TOP]: TournamentsHotSection,
};

export function renderSections(
    items: ISection<any>[] = [],
    sectionCustom: object = {},
    listProps?: any
) {
    const sectionMap = Object.assign({}, SECTION_MAP, sectionCustom);
    return items.map((item, index) => {
        if (item.isShuffle) {
            item.items = shuffleItems(item.items);
            item.isShuffle = false;
        }

        return renderSection(sectionMap, item, index, listProps);
    });
}

function renderSection(
    sectionMap: any = {},
    item: ISection<any>,
    index: number,
    listProps?: any
) {
    if (!item.id) {
        return null;
    }

    const Component = sectionMap['' + item.id];

    if (Component) {
        const props = {
            ...item,
            listProps: listProps,
        };

        return <Component key={`section.item.${index}`} {...props} />;
    }

    return null;
}

function shuffleItems(items: any[] = []) {
    const adNativeMap: any = {};
    const length = items.length;

    let _items = items.filter((item, index) => {
        if (!item.contentId) {
            adNativeMap[index] = item;
            return false;
        }
        return true;
    });

    _items = ArrayUtils.shuffle(_items);

    for (let i = 0; i < length; i++) {
        if (adNativeMap[i]) {
            ArrayUtils.insert(_items, adNativeMap[i], i);
        }
    }
    return _items;
}
